import { Component, OnInit, EventEmitter, Output, Input, ElementRef, ViewChild } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import _ from "lodash";
import { TranslateService } from '@ngx-translate/core';

@Component({
   selector: "mapfre-auditlib-item-form",
   templateUrl: "./item-form.component.html",
   styleUrls: ["./item-form.component.scss"]
})
export class ItemFormComponent implements OnInit {
   _columns;
   constructor(private translateService: TranslateService) { }
   lodash = _;

   @Input()
   get columns() {
      return this._columns;
   }
   set columns(value) {
      this._columns = value;
   }

   @Output() cancelled = new EventEmitter();
   @Output() updated = new EventEmitter();
   @Output() actionClicked = new EventEmitter();
   @Output() selectChange = new EventEmitter();
   @Input() form: UntypedFormGroup;
   @Input() nuuma;
   @Input() defaultActions;
   @ViewChild('inputFileForm', { static: false }) file: ElementRef;
   ngOnInit() { }

   onCancelledClicked() {
      this.cancelled.emit(false);
   }

   onSelectChange(event) {
      this.selectChange.emit(event.value)
   }

   fileClicked() {
      this.file.nativeElement.value = null;
      this.file.nativeElement.click();
   }

   sendFile(event, column) {
      this.form.get(column).setValue(event.target.files);
      this.actionClicked.emit({ key: 'upload' });
   }

   onSave(form) {
      this.updated.emit(form);
   }

   get(object, field) {
      return field ? _.get(object, field) : object;
   }

   getName(name) {
      if (name) {
         return name
      } else {
         return this.nuuma
      }
   }

   setBoolean(column, readonly) {
      if (!readonly) {
         this.form.get(column.field).setValue(!this.form.get(column.field).value)
      }
   }

   getDate(date) {
      if (date) {
         return date
      } else {
         return new Date();
      }
   }

   action(event) {
      this.actionClicked.emit(event);
   }

   getIcon(name) {
      name = _.lowerCase(name);

      if (_.includes(name, 'xls')) {
         return 'icon-24-px-doc-excel green-excel';
      }

      if (_.includes(name, 'pdf')) {
         return 'icon-24-px-doc-pdf red-pdf';
      }

      if (_.includes(name, 'ppt')) {
         return 'icon-24-px-doc-ppt orange-ppt';
      }

      if (_.includes(name, 'doc')) {
         return 'icon-24-px-doc-word blue-doc';
      }

      return 'icon-24-px-comunicacion';

   }
   clearParam(event){

   }
}
